import { FC } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoadingProviderWithGlobalLoading } from './components/ui';
import { SelectedUserProvider } from './contexts/SelectedUserContext';
import Layout from './components/Layout';
import WizardLayout from './components/WizardLayout';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import Topics from './pages/Topics';
import Sales from './pages/Sales';
import Marketing from './pages/Marketing';
import Profile from './pages/Profile';
import Login from './pages/Login';
// import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Wizard from './pages/Wizard';
import Users from './pages/Users';
import UserDashboard from './pages/UserDashboard';
import EmailsLogs from './pages/EmailLogs';
import RegisterInternal from './pages/RegisterInternal';
import RegisterExternal from './pages/RegisterExternal';
import DocumentDownloadPage from './pages/DocumentDownloadPage';
import BookingPage from './pages/BookingPage';
import SchedulerLogsPage from './pages/SchedulerLogsPage';
import Payments from './pages/Payments';

const App: FC = () => {
  return (
    <SelectedUserProvider>
      <LoadingProviderWithGlobalLoading>
        <BrowserRouter>
          <Routes>
            <Route path="/documents/:id" element={<DocumentDownloadPage />} />
            {/* Public booking page - uses wildcard to catch malformed tokens with slashes */}
            <Route path="/booking/*" element={<BookingPage />} />
            {/* public routes */}
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              {/* <Route path="/register" element={<Register />} /> */}
              <Route path="/register/internal" element={<RegisterInternal />} />
              <Route path="/register/external" element={<RegisterExternal />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
            </Route>

            {/* protected routes (everything under Layout) */}
            <Route element={<PrivateRoute />}>
              {/* Wizard route (no sidebar) */}
              <Route element={<WizardLayout />}>
                <Route path="/wizard" element={<Wizard />} />
              </Route>

              {/* Main app routes (with sidebar) */}
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/topics" element={<Topics />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/users" element={<Users />} />
                <Route path="/user/:userId" element={<UserDashboard />} />
                <Route path="/marketing" element={<Marketing />} />
                <Route path="/emaillogs" element={<EmailsLogs />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/scheduler-logs" element={<SchedulerLogsPage />} />
                <Route index element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Route>

            {/* 404 route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </LoadingProviderWithGlobalLoading>
    </SelectedUserProvider>
  );
};

export default App;
